import { formatApiDate, getMonthYear, parseAppDate } from "@/utils/dates/dateFormats";
import { getToday } from "@/utils/dates/dateUtils";
import { endOfMonth, format, isValid, startOfMonth } from "date-fns";
import { capitalize } from "lodash";
import { es } from "date-fns/locale";

export interface ExecutionMonthRange {
  startDate: Date;
  endDate: Date;
}

function parseMonthDate(date: Date | string | null | undefined): Date | null {
  if (date == null || date === "") return null;
  if (date instanceof Date) return isValid(date) ? date : null;
  const parsedDate = parseAppDate(String(date), false);
  return parsedDate && isValid(parsedDate) ? parsedDate : null;
}

export function getCurrentExecutionMonth(): Date {
  return startOfMonth(getToday());
}

export function getExecutionMonthRange(month: Date | string | null | undefined): ExecutionMonthRange | null {
  const parsedMonth = parseMonthDate(month);
  if (!parsedMonth) return null;

  const monthStart = startOfMonth(parsedMonth);
  return { startDate: monthStart, endDate: endOfMonth(monthStart) };
}

export function hasValidExecutionMonth(month: Date | string | null | undefined): boolean {
  return getExecutionMonthRange(month) !== null;
}

export function getExecutionMonthLabel(startDate: Date | null | undefined): string {
  if (!startDate) return "--";
  return getMonthYear(startDate);
}

export function getExecutionMonthOnlyLabel(startDate: Date | null | undefined): string {
  if (!startDate) return "--";
  return capitalize(format(startDate, "MMMM", { locale: es })).toString();
}

export function getWorksheetDateFiltersFromMonth(month: Date | string | null | undefined): {
  fromDate: string | null;
  untilDate: string | null;
} {
  const monthRange = getExecutionMonthRange(month);

  return {
    fromDate: monthRange ? formatApiDate(monthRange.startDate) : null,
    untilDate: monthRange ? formatApiDate(monthRange.endDate) : null,
  };
}
